import Vue from 'vue';

const self = new Vue();

const state = {
  vibbrante: {},
  vibbrante_pending_contracts: [],
  vibbrante_active_contracts: [],
  vibbrante_closed_contracts: [],
  current_contract: {},
  vibbrante_balances: {},
  vibbrante_notifications: [],
};

const actions = {
  loadVibbranteProfileData(context, response) {
    context.commit('LOAD_VIBBRANTE_PROFILE', response);
  },
  loadVibbranteWaitingAnswerContracts(context, response) {
    context.commit('LOAD_VIBBRANTE_PENDING_CONTRACTS', response);
  },
  loadVibbranteActivesContracts(context, response) {
    context.commit('LOAD_vibbrante_active_contracts', response);
  },
  loadVibbranteClosedContracts(context, response) {
    context.commit('LOAD_VIBBRANTE_CLOSED_CONTRACTS', response);
  },
  loadVibbranteCurrentContract(context, response) {
    context.commit('LOAD_VIBBRANTE_CURRENT_CONTRACT', response);
  },
  loadVibbranteNotifications(context, response) {
    context.commit('LOAD_VIBBRANTE_NOTIFICATION', response);
  },
  loadVibbranteBalance(context, response) {
    context.commit('VIBBRANTE_BALANCES', response);
  },
};
const mutations = {
  LOAD_VIBBRANTE_PROFILE: (state, response) => {
    state.vibbrante = response;
    state.vibbrante.birth_date = self
      .$moment(response.birth_date, 'YYYY-MM-DD')
      .format('DD/MM/YYYY');
    let statusName = 'Ativo';
    if (response.status === 'inactive') {
      statusName = 'Inativo';
    }
    state.vibbrante.status = {
      id: response.status,
      name: statusName,
    };
  },
  LOAD_VIBBRANTE_PENDING_CONTRACTS: (state, response) => {
    state.vibbrante_pending_contracts = response;
  },
  LOAD_vibbrante_active_contracts: (state, response) => {
    state.vibbrante_active_contracts = response;
  },
  LOAD_VIBBRANTE_CLOSED_CONTRACTS: (state, response) => {
    state.vibbrante_closed_contracts = response;
  },
  LOAD_VIBBRANTE_CURRENT_CONTRACT: (state, response) => {
    state.current_contract = response;
    // state.current_contract.expected_start_date = self.$moment(response.expected_start_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
  },
  LOAD_VIBBRANTE_NOTIFICATION: (state, response) => {
    state.vibbrante_notifications = response;
  },
  VIBBRANTE_BALANCES: (state, response) => {
    state.vibbrante_balances = response;
  },
};
const getters = {
  vibbrante_pending_contracts: state => state.vibbrante_pending_contracts,
  vibbrante_active_contracts: state => state.vibbrante_active_contracts,
  vibbrante_closed_contracts: state => state.vibbrante_closed_contracts,
  vibbrante_current_contract: state => state.current_contract,
  vibbranteProfile: state => state.vibbrante,
  vibbrante_balances: state => state.vibbrante_balances,
  vibbrante_notifications: state => state.vibbrante_notifications,
};

export default {
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/vibbrante.js